import React, { useEffect, useState } from 'react'
import { getDefaultName } from '../utils'
import { loadCity, loadUserTalentsByUser } from '../utils/Network'

export default function UserTalentList({user_id}) {

    const [usertalents, setUserTalents] = useState(null)

    useEffect(() => {
        if (user_id){
            loadUserTalentsByUser(user_id).then(usertalents => {
                console.log(usertalents)
                setUserTalents(usertalents)
            })
        }
    }, [])

    return (
        <ul style={{ listStyle:"none" , padding:0}}>
            {usertalents && usertalents.map((item, i) =>
            (
                <li style={{fontSize:11}}>{getDefaultName(item.talent.names)}</li>
            )

            )}
        </ul>
    )
}
